/** Only retain a canonical activity detail path, never arbitrary URLs or tokens. */
export function activityReturnTo(value: unknown): string | null {
  return typeof value === 'string' && /^\/activity\/[1-9]\d{0,9}$/.test(value) ? value : null
}

export function loginLocation(
  target: { path?: string; query?: Record<string, unknown> },
  name: 'Login' | 'AdminLogin' = 'Login',
) {
  const redirect = activityReturnTo(target.path)
    || (target.path === '/login' || target.path === '/admin-login'
      ? activityReturnTo(target.query?.redirect) : null)
  return redirect ? { name, query: { redirect } } : { name }
}

export function postLoginPath(redirect: unknown, home: string): string {
  return activityReturnTo(redirect) || home
}
